export default {
  classMaterial: {
    id: "",
    classSectionId: null,
    sectionNo: null,
    nameLocal: null,
    nameEng: null,
    uploadPath: null,
    uploadPathUri: null,
    uploadFileName: null,
  },
  classMaterials: [],
  processing: false,
  error: null,
  success: null,
}



